import fpLogoTransparent from "@/assets/logo-transparent.svg?url";
import {
  Card,
  CardContent,
  CardDescription,
  CardHeader,
  CardTitle,
} from "@/components/ui/card";
import type { PropsWithChildren } from "react";

export function AuthLayout({ children }: PropsWithChildren) {
  return (
    <div className="flex flex-col items-center justify-center w-full min-h-screen bg-background bg-[url('https://assets.fiberplane.com/bg.png')] bg-cover bg-center bg-no-repeat">
      <div className="w-full max-w-md p-4 sm:p-8">
        <Card className="w-full backdrop-blur-md bg-white/10 dark:bg-black/10 border-white/20 dark:border-white/10 shadow-2xl">
          <CardHeader className="space-y-4">
            <div className="flex justify-center">
              <div
                className="w-16 h-16 rounded-xl backdrop-blur-sm bg-white/20 dark:bg-white/10 p-2 shadow-lg"
                style={{
                  boxShadow: "0 8px 32px 0 rgba(255, 255, 255, 0.1)",
                }}
              >
                <img
                  src={fpLogoTransparent}
                  alt="Fiberplane Logo"
                  className="w-full h-full"
                />
              </div>
            </div>
            <CardTitle className="text-2xl font-bold text-center text-white dark:text-white">
              Welcome to Fiberplane
            </CardTitle>
            <CardDescription className="text-center text-white/90 dark:text-white/90">
              Sign in to create MCP servers and Hono APIs by chatting with AI.
            </CardDescription>
          </CardHeader>
          <CardContent>
            <div className="h-full">{children}</div>
          </CardContent>
        </Card>
      </div>
    </div>
  );
}
